// extracted by mini-css-extract-plugin
export default {"inputBlock":"OnlyDropDown_inputBlock__Ouek9","inputField":"OnlyDropDown_inputField__YYOp+","placeholder":"OnlyDropDown_placeholder__9GcvZ"};